import { useState, type Dispatch, type SetStateAction } from 'react';

export type InfoPopupState = {
  infoOpen: boolean;
  setInfoOpen: Dispatch<SetStateAction<boolean>>;
};

export type InfoPopupModelSlice = InfoPopupState & {
  onInfoClick?: () => void;
};

export function useInfoPopupState(): InfoPopupState {
  const [infoOpen, setInfoOpen] = useState(false);
  return { infoOpen, setInfoOpen };
}
